import React, {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import TechnicalDetailsSlider from '@adv-mt/mt-technical-details-slider'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

const BASE_CLASS = 'mt-TechnicalDetailsPanelSlider'
const SLIDER_WRAPPER = `${BASE_CLASS}-sliderWrapper`
const TITLE_CLASS = `${BASE_CLASS}-title`

function TechnicalDetailsPanelSlider({title, description, images}) {
  const {i18n} = useContext(Context)

  const localize = item => {
    if (typeof item !== 'object') return item

    let {literal, params} = item
    const values = Object.entries(params)

    const getValue = value => (value?.isCurrency ? i18n.c(value.currencyValue) : value)

    params = values.reduce((acc, [key, value]) => {
      acc[key] = getValue(value)
      return acc
    }, {})

    return i18n.t(literal, {
      highlightStart: '<strong>',
      highlightEnd: '</strong>',
      smallStart: '<small>',
      smallEnd: '</small>',
      ...params
    })
  }

  return (
    <div className={BASE_CLASS}>
      <div className={TITLE_CLASS}>
        <TitleBasic
          as={titleBasicTags.h1}
          title={localize(title)}
          description={localize(description)}
          size={titleBasicSizes.m}
        />
      </div>
      <div className={SLIDER_WRAPPER}>
        <TechnicalDetailsSlider images={images} />
      </div>
    </div>
  )
}

TechnicalDetailsPanelSlider.displayName = 'TechnicalDetailsPanelSlider'
TechnicalDetailsPanelSlider.propTypes = {
  title: PropTypes.shape({
    literal: PropTypes.string.isRequired,
    params: PropTypes.object
  }).isRequired,
  description: PropTypes.string,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      alt: PropTypes.string,
      title: PropTypes.string
    })
  ).isRequired
}

export default TechnicalDetailsPanelSlider
